import { combineReducers } from "redux";
import createNamedWrapperReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/wrapperReducer";
import DpiDetails from "./DpDetails";
import DpiCharges from "./DpCharges";
export default combineReducers({
    dpiDetails: createNamedWrapperReducer(DpiDetails, "dpiDetails"),
    dpiCharges: createNamedWrapperReducer(DpiCharges, "dpiCharges"),
});
